import type { Document, NodeId, SourceId } from '@/core/document'
import type { ExportOptions } from '@/core/export'

export const DB_NAME = 'insta-little-helper'
export const DB_VERSION = 2
export const MAX_RECENT_EDITS = 20
export const THUMBNAIL_MAX_SIZE = 256
export const AUTOSAVE_DEBOUNCE_MS = 500

export enum StoreName {
  RecentEdits = 'recentEdits',
  SharedInbox = 'sharedInbox',
}

export enum PersistenceStatus {
  Idle = 'idle',
  Saving = 'saving',
  Saved = 'saved',
  Disabled = 'disabled',
}

export interface PersistedSourceRecord {
  id: SourceId
  fileName: string
  mimeType: string
  width: number
  height: number
  file: Blob
}

export interface RecentEditRecord {
  id: string
  createdAt: number
  updatedAt: number
  isOpen: boolean
  sources: readonly PersistedSourceRecord[]
  thumbnail: Blob
  document: Document
  selectedNodeId: NodeId | null
  exportOptions: ExportOptions
}

export interface SharedInboxRecord {
  id: string
  bytes: ArrayBuffer
  fileName: string
  mimeType: string
  receivedAt: number
}
